import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-component p-fluid p-input-filled p-formgrid p-grid p-px-2" }
const _hoisted_2 = { class: "p-field p-col-12 p-text-left" }
const _hoisted_3 = { for: "firstname" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "p-field p-col-12 p-text-left" }
const _hoisted_6 = { for: "lastname" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "p-field p-col-12 p-text-left" }
const _hoisted_9 = { for: "email" }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = {
  key: 1,
  class: "p-error"
}
const _hoisted_12 = { class: "p-field p-col-12 p-text-left" }
const _hoisted_13 = { for: "password" }
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = {
  key: 1,
  class: "p-error"
}
const _hoisted_16 = {
  key: 2,
  class: "p-error"
}
const _hoisted_17 = {
  key: 3,
  class: "p-error"
}
const _hoisted_18 = {
  key: 4,
  class: "p-error"
}
const _hoisted_19 = { class: "p-field p-col-12 p-text-left" }
const _hoisted_20 = { for: "passwordRepeat" }
const _hoisted_21 = {
  key: 0,
  class: "p-error"
}
const _hoisted_22 = {
  key: 1,
  class: "p-error"
}
const _hoisted_23 = { class: "p-col-12 p-mt-2 p-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_BlockUI, { blocked: _ctx.blocked }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('System-Administration.Login.Firstname')) + " *", 1),
          _createVNode(_component_InputText, {
            id: "firstname",
            modelValue: _ctx.v$.firstname.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.firstname.$model) = $event)),
            modelModifiers: { trim: true },
            class: _normalizeClass({'p-invalid':_ctx.v$.firstname.$invalid && _ctx.showErrorMessage}),
            onChange: _ctx.update,
            onKeydown: _ctx.onKeyDown,
            required: "true",
            autofocus: ""
          }, null, 8, ["modelValue", "class", "onChange", "onKeydown"]),
          (_ctx.v$.firstname.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('System-Administration.Login.Firstname')})), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('System-Administration.Login.Lastname')) + " *", 1),
          _createVNode(_component_InputText, {
            id: "lastname",
            modelValue: _ctx.v$.lastname.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.lastname.$model) = $event)),
            modelModifiers: { trim: true },
            class: _normalizeClass({'p-invalid':_ctx.v$.lastname.$invalid && _ctx.showErrorMessage}),
            onChange: _ctx.update,
            onKeydown: _ctx.onKeyDown,
            required: "true",
            autofocus: ""
          }, null, 8, ["modelValue", "class", "onChange", "onKeydown"]),
          (_ctx.v$.lastname.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('System-Administration.Login.Lastname')})), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('System-Administration.Login.Email')) + " *", 1),
          _createVNode(_component_InputText, {
            id: "email",
            modelValue: _ctx.v$.email.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.email.$model) = $event)),
            modelModifiers: { trim: true },
            class: _normalizeClass({'p-invalid':_ctx.v$.email.$invalid && _ctx.showErrorMessage}),
            onChange: _ctx.update,
            onKeydown: _ctx.onKeyDown,
            required: "true",
            autofocus: ""
          }, null, 8, ["modelValue", "class", "onChange", "onKeydown"]),
          (_ctx.v$.email.required.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('System-Administration.Login.Email')})), 1))
            : _createCommentVNode("", true),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
          (_ctx.v$.email.email.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.$t('Forms.Val.Email')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('System-Administration.Login.Password')) + " *", 1),
          _withDirectives(_createVNode(_component_Password, {
            id: "password",
            modelValue: _ctx.v$.password.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.password.$model) = $event)),
            modelModifiers: { trim: true },
            class: _normalizeClass({'p-invalid':_ctx.v$.password.$invalid && _ctx.showErrorMessage}),
            required: "",
            feedback: false,
            onChange: _ctx.update,
            onKeydown: _ctx.onKeyDown
          }, null, 8, ["modelValue", "class", "onChange", "onKeydown"]), [
            [
              _directive_tooltip,
              _ctx.passwordValidationRules,
              void 0,
              { bottom: true }
            ]
          ]),
          (_ctx.v$.password.$invalid && _ctx.showErrorMessage && _ctx.v$.password.passwordLengthValidation && !_ctx.v$.password.passwordLengthValidation.$invalid)
            ? (_openBlock(), _createElementBlock("small", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('System-Administration.Login.Password')})) + " ", 1),
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.v$.password.passwordLengthValidation && _ctx.v$.password.passwordLengthValidation.$invalid && _ctx.showErrorMessage && _ctx.v$.password.minOneLowerAndUpperCaseValidation && !_ctx.v$.password.minOneLowerAndUpperCaseValidation.$invalid)
            ? (_openBlock(), _createElementBlock("small", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.PasswordLength')) + " ", 1),
                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.v$.password.minOneLowerAndUpperCaseValidation && _ctx.v$.password.minOneLowerAndUpperCaseValidation.$invalid && _ctx.showErrorMessage && _ctx.v$.password.atLeastOneNumberValidation && !_ctx.v$.password.atLeastOneNumberValidation.$invalid)
            ? (_openBlock(), _createElementBlock("small", _hoisted_16, [
                _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.MinOneLowerAndUpperCase', { field: _ctx.$t('Squeeze.Login.Password')})) + " ", 1),
                _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.v$.password.atLeastOneNumberValidation && _ctx.v$.password.atLeastOneNumberValidation.$invalid && _ctx.showErrorMessage && _ctx.v$.password.atLeastOneSpecialCharacterValidation && !_ctx.v$.password.atLeastOneSpecialCharacterValidation.$invalid)
            ? (_openBlock(), _createElementBlock("small", _hoisted_17, [
                _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.AtLeastOneNumber', { field: _ctx.$t('Squeeze.Login.Password')})) + " ", 1),
                _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.v$.password.atLeastOneSpecialCharacterValidation && _ctx.v$.password.atLeastOneSpecialCharacterValidation.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_18, [
                _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.AtLeastOneSpecialCharacter', { field: _ctx.$t('Squeeze.Login.Password')})) + " ", 1),
                _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('System-Administration.Login.PasswordRepeat')) + " *", 1),
          _createVNode(_component_Password, {
            id: "passwordRepeat",
            modelValue: _ctx.v$.passwordRepeat.$model,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.passwordRepeat.$model) = $event)),
            modelModifiers: { trim: true },
            class: _normalizeClass({'p-invalid': _ctx.v$.passwordRepeat.$invalid && _ctx.showErrorMessage}),
            required: "",
            feedback: false,
            onChange: _ctx.update,
            onKeydown: _ctx.onKeyDown
          }, null, 8, ["modelValue", "class", "onChange", "onKeydown"]),
          (_ctx.v$.passwordRepeat.required.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_21, [
                _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('System-Administration.Login.PasswordRepeat')})) + " ", 1),
                _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.v$.passwordRepeat.sameAsPassword.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(_ctx.$t('System-Administration.Login.PasswordRepeatMessage')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_Button, {
            icon: "mdi mdi-arrow-right",
            class: "p-button-rounded p-button-outlined",
            onClick: _ctx.goToNextStep
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["blocked"]))
}